import type { PricesEntry } from '@cocoonspace/sdk-js/types/pricesEntry'
import type { SpaceHours } from '@cocoonspace/sdk-js/types/spaceHours'
import { bookingConfig } from '@cocoonspace/shared/config/booking-config'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'

import { getWeekdayFromDate } from '~/utils/get-weekday-from-date'

const { getTimeAsMinutes } = dateTimeUtils.utils

export const MULTIDATE_MIN_AVAILABLE_HOURS = bookingConfig.weekDailyHours

export const isAvailableForFullDay = (entry: PricesEntry) =>
	!entry.closed && entry.available === true

export const getOpeningHoursDuration = (day: string, hours?: SpaceHours) => {
	const dayLabel = getWeekdayFromDate(day) as keyof SpaceHours
	const dayHours = hours?.[dayLabel]

	if (!dayHours || dayHours.closed || !dayHours.open?.length) return 0

	return (
		dayHours.open.reduce(
			(total, { from, to }) =>
				total + (getTimeAsMinutes(to) - getTimeAsMinutes(from)),
			0,
		) / 60
	)
}

export const hasMinOpeningHours = (
	day: string,
	minHours: number,
	spaceHours?: SpaceHours,
) => getOpeningHoursDuration(day, spaceHours) >= minHours

export const isMultidateSelectableDay = (
	entry: PricesEntry,
	minHours: number,
	spaceHours?: SpaceHours,
) =>
	isAvailableForFullDay(entry) &&
	hasMinOpeningHours(entry.day, minHours, spaceHours)
